/*
  Savigni: megamenu del menu principale.
  Con il mouse i pannelli si aprono al passaggio e si chiudono uscendo (con un piccolo ritardo, per
  non chiuderli attraversando lo spazio tra voce e pannello). Al clic e da tastiera resta il
  comportamento del tema (header-menu); Esc chiude il pannello aperto e riporta il fuoco sulla voce.
*/
(function () {
  'use strict';

  var voci = document.querySelectorAll('.sv-menu__voce--pannello');
  if (!voci.length) return;

  function chiudi(details) {
    if (!details.hasAttribute('open')) return;
    details.removeAttribute('open');
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function apri(details) {
    document.querySelectorAll('.sv-mega[open]').forEach(function (d) { if (d !== details) chiudi(d); });
    if (details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'true');
  }

  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');

  voci.forEach(function (voce) {
    var details = voce.querySelector('details.sv-mega');
    if (!details) return;
    var timer = null;

    voce.addEventListener('mouseenter', function () {
      if (!mouse.matches) return;
      clearTimeout(timer);
      apri(details);
    });
    voce.addEventListener('mouseleave', function () {
      if (!mouse.matches) return;
      timer = setTimeout(function () { chiudi(details); }, 180);
    });
    details.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      chiudi(details);
      var s = details.querySelector('summary');
      if (s) s.focus();
    });
  });
})();
